module.exports = __webpack_public_path__ + "static/media/BOM.0ea074c7.svg";